<template>
  <div class="form-wrap">
    <div class="form-control-content" v-if="submits">
      <v-btn pill
        class="submit-icon bg-transparent border-0 py-8"
        @click="$emit('submit')"
      >
        <v-icon :icon="submitIcon"></v-icon>
      </v-btn>
    </div>

    <input
      :id="id"
      ref="input"
      :autocomplete="autocomplete"
      :disabled="disabled"
      :placeholder="placeholder"
      :value="value"
      :type="type"
      @keyup.enter="$emit('enter')"
      v-model="localValue"
      :class="[classes, calcRadius, calcBg]"
    >

    <label
      v-if="!!label"
      ref="label"
      :class="{'invisible': hiddenLabel}"
      :for="id"
    >{{ label }}</label>

    <v-btn
      v-if="clearable && !!localValue && localValue.length > 0"
      class="clear-icon bg-transparent border-0"
      @click="clear"
    >
      <v-icon :icon="clearIcon"></v-icon>
    </v-btn>
  </div>
</template>

<script>

import VIcon from '../VIcon';

export default {
  name: 'VTextField',
  components: {VIcon},
  emits: ['change', 'enter', 'clear', 'submit'],
  props: {
    id: {
      type: String,
      required: true,
    },
    value: {},
    type: {
      type: String,
      required: false,
      default: 'text',
    },
    size: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: null,
    },
    autocomplete: {
      type: String,
      required: false,
      default: null,
    },
    label: {
      type: String,
      required: false,
      default: null,
    },
    hiddenLabel: {
      type: Boolean,
      required: false,
    },
    radius: {
      type: String,
      required: false,
      default: null,
    },
    bg: {
      type: String,
      required: false,
      default: null,
    },
    submits: Boolean,
    submitIcon: {
      type: String,
      default: 'search',
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
    clearIcon: {
      type: String,
      default: 'close',
    },
  },
  data() {
    return {
      localValue: this.value
    };
  },
  computed: {
    calcRadius() {
      return this.radius ? `rounded-${this.radius}` : '';
    },
    calcBg() {
      return this.bg ? `bg-${this.bg}` : '';
    },
    classes() {
      return {
        'form-control': !['checkbox', 'radio'].includes(this.type),
        'form-control-button': !!this.submits,
        'form-control-sm': !!this.size && this.size === 'sm',
        'form-control-lg': !!this.size && this.size === 'lg',
      }
    }
  },
  watch: {
    localValue(value) {
      this.$emit('input', value)
    },
    value(value) {
      this.localValue = value
    }
  },
  methods: {
    updateValue() {
      this.$emit('change', this.value);
    },
    clear() {
      this.localValue = '';
      this.$emit('clear')
    },
    focus() {
      this.$refs.input.focus();
    },
  },
};
</script>

<style lang="scss">
@import "VTextField";
</style>
